export function initMobileMenu() {
    const body = document.body;
    const catalogBtn = document.querySelector<HTMLButtonElement>('.button-catalog');
    const menuSubs = document.querySelectorAll<HTMLElement>('.menu-item_sub');

    if (!catalogBtn || !menuSubs.length) return;

    // функция инициализации меню для мобильных
    const initMenu = () => {
        // 1) открыть мобильное меню
        catalogBtn.addEventListener('click', () => {
            body.classList.add('mobile-menu-show');
        });

        // 2) открыть submenu по data-menu
        document.querySelectorAll<HTMLElement>('.menu-link[data-menu]').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const key = link.getAttribute('data-menu');
                if (!key) return;

                const sub = document.querySelector<HTMLElement>(`.menu-item_sub[data-main-menu="${key}"]`);
                if (!sub) return;

                sub.classList.add('active');
            });
        });

        // 3) menu-back внутри submenu
        menuSubs.forEach(sub => {
            // menu-back в правой колонке → вернуться к левой колонке
            sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-right .menu-back').forEach(backBtn => {
                backBtn.addEventListener('click', () => {
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-items.show').forEach(item => item.classList.remove('show'));
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-right.active').forEach(col => col.classList.remove('active'));
                    sub.classList.add('active');
                });
            });

            // menu-back в левой колонке → закрыть submenu
            sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-left .menu-back').forEach(backBtn => {
                backBtn.addEventListener('click', () => {
                    sub.classList.remove('active');
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-items.show').forEach(item => item.classList.remove('show'));
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-right.active').forEach(col => col.classList.remove('active'));
                });
            });
        });

        // 4) menu-item_sub-trigger
        menuSubs.forEach(sub => {
            sub.querySelectorAll<HTMLElement>('.menu-item_sub-trigger[data-id]').forEach(trigger => {
                trigger.addEventListener('click', () => {
                    const id = trigger.getAttribute('data-id');
                    if (!id) return;

                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-items.show').forEach(item => item.classList.remove('show'));
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-right.active').forEach(col => col.classList.remove('active'));

                    const target = sub.querySelector<HTMLElement>(`.menu-item_sub-items[data-menu-id="${id}"]`);
                    if (target) {
                        target.classList.add('show');
                        const rightCol = target.closest<HTMLElement>('.menu-item_sub-column-right');
                        if (rightCol) rightCol.classList.add('active');
                    }
                });
            });
        });

        // 5) menu-close внутри submenu
        menuSubs.forEach(sub => {
            sub.querySelectorAll<HTMLElement>('.menu-close').forEach(closeBtn => {
                closeBtn.addEventListener('click', () => {
                    body.classList.remove('mobile-menu-show');
                    sub.classList.remove('active');
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-items.show').forEach(item => item.classList.remove('show'));
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-right.active').forEach(col => col.classList.remove('active'));
                });
            });
        });

        // menu-close в header-bottom
        document.querySelectorAll<HTMLElement>('.header-bottom .menu-close').forEach(closeBtn => {
            closeBtn.addEventListener('click', () => {
                body.classList.remove('mobile-menu-show');
                menuSubs.forEach(sub => {
                    sub.classList.remove('active');
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-items.show').forEach(item => item.classList.remove('show'));
                    sub.querySelectorAll<HTMLElement>('.menu-item_sub-column-right.active').forEach(col => col.classList.remove('active'));
                });
            });
        });
    };

    // проверяем ширину экрана
    if (window.innerWidth < 991) {
        initMenu();
    }

    // опционально: при изменении размера окна
    window.addEventListener('resize', () => {
        if (window.innerWidth < 991 && !body.classList.contains('mobile-menu-init')) {
            initMenu();
            body.classList.add('mobile-menu-init'); // чтобы не инициализировать заново
        }
    });
}
